const zonesKeys = {
  ZPAR: [
    {
      zone: 'Belgrano',
      subzone: 'Barrio Chino, Belgrano R, Belgrano C, Belgrano Chico, Barrio Parque General Belgrano.'
    },
    {
      zone: 'Palermo',
      subzone:
        'Palermo Chico, Palermo Soho, Palermo Hollywood, Palermo Viejo, Palermo Nuevo, Las cañitas, Botánico, Barrio Parque.'
    },
    {
      zone: 'Nordelta',
      subzone:
        'Los Castaños, El Palmar, El Golf, El Yacht, Puerto Escondido, Bahia Grande, Los Castores, Portezuelo, Tipas.',
      hiddenSubzone:
        'Los Castaños, El Palmar, El Golf, El Yacht, Puerto Escondido, Bahia Grande, Los Castores, Portezuelo, Tipas, Barrancas del Lago, La Alameda, La Isla, Las Caletas, Las Glorietas, Cabos del Lago, Los Sauces, Lagos del Golf, Los Alisos, Los Lagos, Miradores de la Bahía, Studios de la Bahía, Terrazas de la Bahía, Paseo de la Bahia, Lago Escondido, Albatros, Antares, Bigua, Cormoran, El Faro, Marinas del Canal, Martín Pescador, Metro Marinas, North Coral Plaza, Petrel, Puerta Norte, Quartier Nordelta, Ribera, Solares Portezuelo, Vista Bahía, El Reflejo, Sendero, Los Tilos, Yoo Nordelta, Castaños - Las Piedras, Virazón, Enyoi, Chateau del Portal, Qbay Yacht, Espigón 12, Espigón 13, Zaduh, Delta 8, Islas del Canal, Wyndham Loft, Wyndham Condominios, Wyndham Suites, El Portal, Vientos del Delta, Loft del Sendero, Casas del Sendero, Panorama, Lagos del Sendero, Plaza Sendero, Casas del Sol, Casas del Lago, Casas del Sol del Este, Condominios de la Bahia, Praia, Solares de Portezuelo, Plaza Portezuelo, Marinas del Portezuelo, Portezuelo Homes, Jardines Palmar, Chateau del Palmar, Zerena, Posadas, Del Lago Condominium, Infinity, Insignia, Homes 3, Homes 2, La Mansa, Aqua Golf I, Qbay Golf, Puertos del lago-Costas, Carpinchos, Acqua Río, Flumine, Islas del Golf, Chateau del Palmar II, Puentes, Q-Bay, Aqua Golf II, Nordelta Golf Club, Puerto Escondido - Q Bay, Vilago Nordelta Rio, Suites Intercontinental, Lofts de la Bahía, Marinas del Yacht, Castaños - La Balconada.',
      withMoreZonesCTA: true,
      topM: '62',
      topD: '62',
      topTH: '62',
      topTV: '43',
      leftM: '33',
      leftD: '33',
      leftTV: '210',
      leftTH: '33'
    },
    { zone: 'Núñez', subzone: 'Lomas de Núñez.' },
    { zone: 'Recoleta y Barrio Norte', subzone: '' },
    { zone: 'Caballito', subzone: 'Caballito Norte, Primera Junta, Parque Rivadavia, Cid Campeador, Caballito Sur.' },
    { zone: 'Puerto Madero', subzone: '' },
    { zone: 'Villa Urquiza', subzone: '' }
  ],
  '24MX': [
    { zone: 'Alvaro Obregón' },
    { zone: 'Cuajimalpa' },
    { zone: 'Magdalena Contreras' },
    { zone: 'Miguel Hidalgo' }
  ],
  UBPE: [
    { zone: 'Barranco', subzone: '' },
    { zone: 'San Borja', subzone: '' },
    { zone: 'Miraflores', subzone: '' },
    { zone: 'San Isidro', subzone: '' },
    { zone: 'La Molina', subzone: '' },
    { zone: 'Santiago de Surco', subzone: '' }
  ]
};

export { zonesKeys };
